export const primaryColorScale = {
    0: "#000000",
    5: "#00201E",
    10: "#002B29",
    15: "#003735",
    20: "#004340",
    25: "#00504C",
    30: "#006A66",
    35: "#145C59",
    40: "#00837E",
    50: "#00A29B",
    60: "#28BEB7",
    70: "#6FD8D2",
    80: "#9AE6E1",
    90: "#C6F7F3",
    95: "#E3FFFC",
    98: "#F2FFFD",
    99: "#F8FFFE",
    100: "#FFFFFF",
};
